'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_navigation_Paginator_Paginator = require('./Paginator.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const PaginatorStateful = (_a) => {
  var { initialPageIndex = 0, onPaginate } = _a, props = tslib_es6.__rest(_a, ["initialPageIndex", "onPaginate"]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(initialPageIndex);
  const onPaginateStateful = React.useCallback((data, event) => {
    setCurrentPageIndex(data.pageIndex);
    if (onPaginate) {
      onPaginate(data, event);
    }
  }, [onPaginate]);
  return React__default.default.createElement(components_navigation_Paginator_Paginator.Paginator, Object.assign({}, props, { currentPageIndex, onPaginate: onPaginateStateful }));
};

exports.PaginatorStateful = PaginatorStateful;
//# sourceMappingURL=PaginatorStateful.cjs.js.map
